import React from "react";

const MAP = {
  active: { label: "Aktif", cls: "bg-emerald-100 text-emerald-700" },
  due: { label: "Jatuh Tempo", cls: "bg-amber-100 text-amber-700" },
  expired: { label: "Expired", cls: "bg-red-100 text-red-700" },
};

export default function StatusBadge({ status, testid }) {
  const s = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return (
    <span data-testid={testid} className={`inline-block rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${s.cls}`}>
      {s.label}
    </span>
  );
}
